import ServiciosGeneral from "./ServiciosGeneral";

const servicios = {
  
  reporteTIS: ServiciosGeneral.llamarServidorRespuestaPost("Reportes/reporteTIS"),
  getGteProgra: ServiciosGeneral.llamarServidorRespuestaPost("Reportes/getGteProgra"),
  // reporteTIS: ServiciosGeneral.llamarServidorRespuesta("Tareas/tareasUpdate"),
  // cerrartareasUpdate: ServiciosGeneral.llamarServidorRespuesta("Tareas/cerrartareasUpdate"),
  // tareasAll: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/tareasAll"),
  getsolporsistema: ServiciosGeneral.llamarServidorRespuestaPost("/Reportes/solxSistema"),
  getIntegrantes: ServiciosGeneral.llamarServidorRespuestaPost("/Reportes/integrantes"),
  getTareaxSolicitud: ServiciosGeneral.llamarServidorRespuestaPost("/Reportes/getTareaxSolicitud")
};
export default servicios;
